// work data

export const Work = [
    {
        id:1,
        name:"News App",
        description:"It is a android based news app which gather news from all the websites. It uses free API to gather all information.",
        tags:["kotlin","Api","public api"],
        
        demo:"https://agency-website-eta.vercel.app/",
        github:"https://github.com/DevanshuChauhan1999/FlashNews"
    },
    
    
  
] 